import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log('🔒 authGuard called for route:', state.url);
  const isAuth = authService.isAuthenticated();
  console.log('🔒 authService.isAuthenticated() returned:', isAuth);

  if (isAuth) {
    console.log('✅ authGuard: User is authenticated, allowing access');
    return true;
  }

  // Remember where they were headed so the sign-in round trip can put them
  // back there. rememberRoute() decides what is worth remembering — the
  // Impersonate ("View As") picker, for one, never is.
  authService.rememberRoute(state.url);

  console.log('❌ authGuard: User not authenticated, redirecting to root');
  console.log('❌ Stored target route:', state.url);
  // Redirect to login
  router.navigate(['/']);
  return false;
};